module.exports = __webpack_public_path__ + "img/myFlex_white.d5b2169b.png";